import React from 'react';
import { TFunction } from 'i18next';

import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import { INotificationTemplate } from '../../../../types/interfaces/notification-admin';
import {
  notificationCategoryLabel,
  notificationDisplayDomainLabel,
  notificationPreferenceGroupLabel,
} from '../../../../utils/notification-template-labels';
import { NOTIFICATION_TEMPLATE_COLUMN_IDS } from './notificationTemplatesTableColumns';

export function getNotificationTemplatesCellReducers(
  t: TFunction,
  classes: { codeLink?: string; actions?: string },
  opts: { canDelete: boolean },
  onOpen: (row: INotificationTemplate) => void,
  onDelete: (row: INotificationTemplate) => void,
) {
  const base = [
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.CODE,
      cellReducer: (row: INotificationTemplate) => (
        <div
          className={classes.codeLink}
          onClick={() => onOpen(row)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onOpen(row);
          }}
          role="button"
          tabIndex={0}>
          {row.code}
        </div>
      ),
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.CATEGORY,
      cellReducer: (row: INotificationTemplate) => (
        <div>{notificationCategoryLabel(t, row.category)}</div>
      ),
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.PREFERENCE_GROUP,
      cellReducer: (row: INotificationTemplate) => (
        <div>{notificationPreferenceGroupLabel(t, row.preferenceGroup)}</div>
      ),
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.DISPLAY_DOMAIN,
      cellReducer: (row: INotificationTemplate) => (
        <div>{notificationDisplayDomainLabel(t, row.displayDomain)}</div>
      ),
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIVE,
      cellReducer: (row: INotificationTemplate) => (
        <div>{row.active ? t('common.active') : t('common.notActive')}</div>
      ),
    },
    {
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.UPDATED_AT,
      cellReducer: (row: INotificationTemplate) => (
        <div>{new Date(row.updatedAt).toLocaleString()}</div>
      ),
    },
  ];
  if (opts.canDelete) {
    base.push({
      id: NOTIFICATION_TEMPLATE_COLUMN_IDS.ACTIONS,
      cellReducer: (row: INotificationTemplate) => (
        <div className={classes.actions}>
          <DeleteActionButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete(row);
            }}
          />
        </div>
      ),
    });
  }
  return base;
}
